import CryptoJS from 'crypto-js';

class  AesUtil {

     init(keySize, iterationCount) {
        this.keySize = keySize / 32;
        this.iterationCount = iterationCount;
    };

     generateKey = function(salt, passPhrase) {
         let key = CryptoJS.PBKDF2(
             passPhrase,
             CryptoJS.enc.Hex.parse(salt),
             { keySize: this.keySize, iterations: this.iterationCount });
         return key;
     };

    encrypt(salt, iv, passPhrase, plainText){
        try{
            let key = this.generateKey(salt, passPhrase);
            let encrypted = CryptoJS.AES.encrypt(
                plainText,
                key,
                { iv: CryptoJS.enc.Hex.parse(iv) });
            return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
        }catch(e){
            console.log('encrypt function in AesUtil ',e)
        }
    }

    decrypte(salt, iv, passPhrase, cipherText){
        try{
            let key = this.generateKey(salt, passPhrase);
            let cipherParams = CryptoJS.lib.CipherParams.create({
                ciphertext: CryptoJS.enc.Base64.parse(cipherText)
            });
            let decrypted = CryptoJS.AES.decrypt(
                cipherParams,
                key,
                { iv: CryptoJS.enc.Hex.parse(iv) });
            return decrypted.toString(CryptoJS.enc.Utf8);
        }catch(e){
            console.log('decrypte function in AesUtil ',e)
        }
    }
}
export default new AesUtil();